app.factory('dataShare', function () {
    var service = {};
    service.data = [];
    service.data.addons = [];
    service.data.products = [];
    service.data.client = [];
    service.data.orderInfo = [];

    return {
        data: {
            NameSpace: infoData.NameSpace,
            GymID: infoData.GymID
        },
        addClient: function (d) {
            return service.data.client.push(d);
        },
        addAddon: function (d) {
            return service.data.addons.push(d);
        },
        addProduct: function (d) {
            return service.data.products.push(d);
        },
        addData: function (d) {
            return service.data.push(d);
        },
        addInfo: function (d) {
            return service.data.orderInfo = d;
        },
        getData: function () {
            return service.data;
        }
    };
});

app.factory('getServicesAndProducts', ['$http', function ($http) {
    var url = new URL(window.location.href);
    let params = url.searchParams;
    const newParams = new URLSearchParams();
    for (const [name, value] of params) {
        newParams.append(name.toLowerCase(), value);
    }

    var categoryID = newParams.get("categoryid");
    var subCategoryID = newParams.get("subcategoryid");
    var visitDefinitionID = newParams.get("visitdefinitionid");

    var getServicesAndProducts = {
        async: function () {

            if( filteredSubCatID != null ){
                categoryID = null;
            }

            var parameters = {
                NameSpace: infoData.NameSpace,
                GymID: infoData.GymID,
                CategoryID: filteredCatID != null ? filteredCatID : categoryID,
                SubCategoryID: filteredSubCatID != null ? filteredSubCatID : subCategoryID,
                VisitDefinitionID: visitDefinitionID
            };
            var config = {
                params: parameters
            };
            // $http returns a promise, which has a then function, which also returns a promise
            var promise = $http.get('/OnlineBooking/GetServicesAndProducts', config).then(function (d) {
                // The return value gets picked up by the then in the controller.
                return d.data;
            });
            // Return the promise to the controller
            return promise;
        }
    };
    return getServicesAndProducts;
}]);

app.factory('Backend', ['$http', function ($http) {
    var service = {};

    service.getServicesAndProductsAsync = function getServicesAndProductsAsync() {
        var params = {
            NameSpace: infoData.NameSpace,
            GymID: infoData.GymID
        };
        return $http.get('/OnlineBooking/GetServicesAndProducts', { params: params })
        .then(function success(response) {
            return response.data;
        });
    };

    service.checkConflictAsync = function checkConflictAsync(orderInfo) {
        return $http.post('/OnlineBooking/CheckConflictList', orderInfo)
        .then(function success(response) {
            var data = response.data;

            var result = {
                data: data
            };

            if (data === null) {
                result.isConflict = true;
                return result;
            }
            else if (Array.isArray(data) === false) {
                result.isConflict = true;
                result.limit = data;
                return result;
            }
            else if (data.length === 0) {
                result.isConflict = true;
                return result;
            }
            else {
                result.isConflict = false;
                return result;
            }
        });
    };

    return service;
}]);